export default __webpack_public_path__ + "static/media/personal-portfolio.be2f5bf5.png";